import { Permissions } from "src/api/generated/iam/permissions.ts";
import { useHasPermission } from "../../common/userPermissions.ts";
import { AsyncButton } from "../../../../common/buttons/AsyncButton.tsx";
import i18n from "i18next";
import { faBoxOpen } from "@fortawesome/pro-regular-svg-icons";
import { PurchaseOrderSourcePickingView } from "./PurchaseOrderSourcePickingView.tsx";
import { DeliveryPackageSource } from "../../../../../api/generated/erp/delivery/model/deliveryPackageSource.ts";
import { useGenericDialog } from "../../../../common/dialogs/GenericDialogContext.ts";
import { PurchaseOrder } from "../../../../../api/generated/erp/db/types/tables/purchaseOrder.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface OpenPurchaseOrderSourcePickingViewButtonProps {
	purchaseOrder: PurchaseOrder;
}

export const OpenPurchaseOrderSourcePickingViewButton = ({
	purchaseOrder,
}: OpenPurchaseOrderSourcePickingViewButtonProps) => {
	const { openDialog } = useGenericDialog();
	const hasPermission = useHasPermission();

	if (purchaseOrder.purchaseOrderType !== "TO_SITE") {
		return null;
	}

	let deliveryPackageSource: DeliveryPackageSource;
	if (
		purchaseOrder.orderSource === "CUSTOMER_ORDER" &&
		purchaseOrder.orderSourceId != null &&
		hasPermission(Permissions.Sales.CustomerOrders.PICK)
	) {
		deliveryPackageSource = {
			type: "customerOrder",
			customerOrderId: purchaseOrder.orderSourceId,
		};
	} else if (
		purchaseOrder.orderSource === "PROJECT" &&
		purchaseOrder.orderSourceId != null &&
		hasPermission(Permissions.Projects.PICK)
	) {
		deliveryPackageSource = {
			type: "project",
			projectId: purchaseOrder.orderSourceId,
		};
	} else {
		return null;
	}

	return (
		<AsyncButton
			label={i18n.t("picking")}
			icon={faBoxOpen}
			variant={"outlined"}
			onClick={() => {
				openDialog({
					title: i18n.t("picking"),
					agentContext: {
						key: defineAgentUiContextKey("erp.purchase.purchaseOrderSourcePicking.dialog"),
						title: i18n.t("picking"),
						data: {
							purchaseOrderId: purchaseOrder.purchaseOrderId,
							orderSource: purchaseOrder.orderSource,
							orderSourceId: purchaseOrder.orderSourceId ?? null,
						},
					},
					content: (
						<PurchaseOrderSourcePickingView
							purchaseOrder={purchaseOrder}
							deliveryPackageSource={deliveryPackageSource}
						/>
					),
				});
			}}
		/>
	);
};
